import { render, staticRenderFns } from "./checkUserImportTemplate.vue?vue&type=template&id=0b8b1155&scoped=true&"
import script from "./checkUserImportTemplate.vue?vue&type=script&lang=js&"
export * from "./checkUserImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./checkUserImportTemplate.vue?vue&type=style&index=0&id=0b8b1155&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b1155",
  null
  
)

export default component.exports